class WorkspaceStyle {
  static cardFooter ='#601c31';

  static cardHeading ='#dd3c3c';

  static workspaceNameCircle = '#5D2835';

  static workspaceAddButtonColor ='#242B2E';

  static zeeveStyle() {
    const style = `.container-workname {
            position: absolute;
            margin-top: -48px;
            height: 60px;
            width: 60px;
            border-radius: 40px;
            background: rgb(7, 62, 243);
          }
        .workSpaceButton{
          background: 'blue';
        }  
        .workname {
            width: 100%;
            text-align: center;
            color: white;
            font-size: 26px;
            font-weight: 500;
            margin-top: 10px;
          }`;
    return style;
  }

  static heliosStyle() {
    const heliosStyle = `.container-workname {
            position: absolute;
            margin-top: -48px;
            height: 70px;
            width: 70px;
            color: white;
            border-radius: 40px;
            background-color: ${this.workspaceNameCircle};
          }
        .workSpaceButton{
          background-color: ${this.workspaceAddButtonColor};
          color: white;
        }
        .workspaceCardHeading{
          color: ${this.cardHeading};
        }
        .card-footer{
          border-radius: 0px 0px 24px 24px !important;
          border-block-start-color:${this.cardFooter};
      }  
        .workname {
            width: 100%;
            text-align: center;
            color: white;
            font-size: 26px;
            font-weight: 500;
            margin-top: 15px;
          }`;
    return heliosStyle;
  }
}
export default WorkspaceStyle;